import React from 'react'

import Button from '../Button'

import classes from './styles'

const Welcome = ({ isLoading, start }) => (
  <div className={classes.welcomeWrapper}>
    <div className={classes.welcome}>
      <div className={classes.logoWrapper}>
        <img className={classes.logo} src="https://10years.lifehacker.ru/static/images/logo_lh.png" alt=""/>
      </div>

      <div className={classes.content}>

        <div className={classes.texts}>
          <h2 className={classes.title}>
            Ты - редактор!
          </h2>

          <div className={classes.description}>
            Задание на сегодня — подготовить текст к публикации.
            В каждом тексте 10 орфографических ошибок. Нужно найти неправильное слово и кликнуть на него. На первом уровне можно ошибаться до 10 раз.
            Найдёшь все ошибки — перейдёшь на следующий уровень. Там снова ждёт текст с ошибками, но лимит неверных кликов становится меньше.
            На последнем уровне нужно найти все слова с ошибками с первой попытки.
          </div>
        </div>

        <div className={classes.footer}>
          <div className={classes.controls}>
            {isLoading ?
              <Button
                disabled={true}
              >
                Ждите
              </Button>
              :
              <Button
                onClick={start}
              >
                Играть
              </Button>
            }
          </div>
        </div>
      </div>

    </div>
  </div>
)

Welcome.propTypes = {
  isLoading: React.PropTypes.bool.isRequired,
  start: React.PropTypes.func.isRequired,
}

export default Welcome


// WEBPACK FOOTER //
// ./src/components/Welcome/Welcome.jsx